import { FaPlus, FaMinus } from "react-icons/fa";
import SelectDropdown from "./forms/selectDropDown";
import { formatString } from "./helper";

const OrderSummary = ({ items, onQuantityChange, onCancel, onSubmit, setPayment, payment }) => {
    const calculateSummary = (items) => {
        let subtotal = 0;
        let totalCgst = 0;
        let totalSgst = 0;
        let totalIgst = 0;
        let grandTotal = 0;

        items.forEach(product => {
            subtotal += product.productPrice * product.quantity;
            totalCgst += product.cgst * product.quantity;
            totalSgst += product.sgst * product.quantity;
            totalIgst += product.igst * product.quantity;
            grandTotal += parseFloat(product.totalPrice);
        });

        return {
            totalGst: totalCgst + totalSgst + totalIgst,
            subtotal: subtotal.toFixed(2),
            totalCgst: totalCgst.toFixed(2),
            totalSgst: totalSgst.toFixed(2),
            totalIgst: totalIgst.toFixed(2),
            grandTotal: grandTotal.toFixed(2),
        };
    };

    const { totalGst, subtotal, totalCgst, totalSgst, totalIgst, grandTotal } = calculateSummary(items);

    return (
        <div className="w-full lg:w-1/4 bg-gray-50 border-l h-full md:h-[90vh] sticky top-0 flex flex-col">
            {/* Header */}
            <div className="px-4 py-3 border-b bg-gray-50 sticky top-0 z-10 text-start">
                <h2 className="text-xl font-bold">Bill Summary</h2>
            </div>

            <div className="mx-2" style={{ width: "100%", maxWidth: "15rem" }}>
                <SelectDropdown
                    label={"Payment Method"}
                    options={[
                        { value: 'cash', label: "Cash" },
                        { value: "online", label: "Online" },
                    ]}
                    value={payment}
                    onChange={(name, value, selectedOption) => {
                        setPayment(value);
                    }}
                    placeholder="Select payment method"
                    name="payment_method"
                    className="w-full z-10"
                    isFormik={false}
                />
            </div>

            <label className="text-lg text-start px-2 py-2">Items</label>
            <div className="flex-1 overflow-y-auto px-4 space-y-4 max-h-[28em]">
                {items.length === 0 ? (
                    <p className="text-gray-500">No items added.</p>
                ) : (
                    items.map((item) => (
                        <div key={item.id} className="flex justify-between items-center border-b pb-2">
                            <div>
                                <p className="font-semibold">{formatString(item.name)}</p>
                                <p className="text-sm text-gray-600">₹{item.productPrice} × {item.quantity}</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => onQuantityChange(item.id, -1)}
                                    className="bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                >
                                    <FaMinus size={12} />
                                </button>
                                <span>{item.quantity}</span>
                                <button
                                    onClick={() => onQuantityChange(item.id, 1)}
                                    className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                >
                                    <FaPlus size={12} />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Summary Section */}
            <div className="px-4 border-t md:space-y-2 text-gray-800 pt-1">
                <p className="flex justify-between"><span>CGST</span> <span>₹{totalCgst}</span></p>
                <p className="flex justify-between"><span>SGST</span> <span>₹{totalSgst}</span></p>
                <p className="flex justify-between"><span>IGST</span> <span>₹{totalIgst}</span></p>
                <p className="flex justify-between"><span>Subtotal</span> <span>₹{subtotal}</span></p>
                <p className="flex justify-between"><span>Total Tax</span> <span>₹{totalGst.toFixed(2)}</span></p>
                <p className="flex justify-between font-bold text-lg"><span>Total</span> <span>₹{grandTotal}</span></p>
            </div>

            {/* Sticky Bottom Buttons */}
            <div className="px-4 py-3 border-t bg-gray-50 z-10 flex justify-between gap-3">
                <button
                    onClick={onCancel}
                    className="bg-gray-300 text-gray-800 py-2 px-4 rounded hover:bg-gray-400 w-1/2"
                >
                    Cancel
                </button>
                <button
                    onClick={onSubmit}
                    disabled={items.length === 0}
                    className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:bg-gray-400 w-1/2"
                >
                    Save & Print
                </button>
            </div>
        </div>
    );
};

export default OrderSummary;
